import InputText from './InputText';
import ControlledComponent from '../../../utils/ControlledComponent';

export const ControlledInputText = ControlledComponent(InputText);

export default InputText;
